import React, { useState } from 'react';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const InitAdmin = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInit = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/init-admin`);
      setResult(response.data);
    } catch (error) {
      setResult({ error: error.response?.data?.detail || error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="text-2xl font-bold text-slate-900 mb-4">Inicializar Usuario Admin</h1>
        <p className="text-sm text-slate-600 mb-6">
          Haz clic en el botón para crear el usuario administrador inicial.
        </p>
        
        <Button
          onClick={handleInit}
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3"
        >
          {loading ? 'Creando...' : 'Crear Usuario Admin'}
        </Button>

        {result && (
          <div className="mt-6 p-4 bg-slate-50 rounded-lg">
            <pre className="text-sm whitespace-pre-wrap">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </Card>
    </div>
  );
};

export default InitAdmin;
